export class State {
}
State.language = "";
State.culture = "";
State.base = "";
